import Col from "react-bootstrap/Col";
import Row from "react-bootstrap/Row";

import { GroupActivityCitizen } from "@/@types/esus/GroupActivityCitizen";

type IndicatorEsbB4CitizenHistoryItemProps = {
	groupActivity: GroupActivityCitizen;
};

export function IndicatorEsbB4CitizenHistoryItem({
	groupActivity,
}: Readonly<IndicatorEsbB4CitizenHistoryItemProps>) {
	return (
		<>
			<Row>
				<Col>
					<p>
						<span className="fw-bold text-primary">Equipe: </span>
						{groupActivity.healthTeam?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="fw-bold text-primary">Unidade: </span>
						{groupActivity.healthUnit?.name ?? "N/A"}
					</p>
				</Col>
			</Row>
			<Row>
				<Col>
					<p>
						<span className="text-primary">Profissional: </span>
						{groupActivity.professional?.name ?? "N/A"}
					</p>
				</Col>
				<Col>
					<p>
						<span className="text-primary">Categoria: </span>
						{groupActivity.cbo?.description?.toUpperCase() ?? "N/A"}
					</p>
				</Col>
			</Row>
		</>
	);
}
